module.exports = __webpack_public_path__ + "static/media/elegir_metodo_run_serial_clave_unica.0c1d43a3.svg";